import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CardItem } from '@/domains/home/apis/home-api';

export interface IpCardItem extends CardItem {
    is_free: boolean;
    is_third_party?: boolean;
}

interface GetIpCardsResponse {
    cards: IpCardItem[];
}

export interface HomeIpApi {
    getIpCards(): Promise<GetIpCardsResponse>;
    getIpProfileToken(): Promise<string>;
}

export const HomeIpApi = Symbol('HomeIpApi');

@injectable()
export class HomeIpApiImpl extends PsHttpService implements HomeIpApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getIpCards() {
        return this.get<PatSnapCommonResponseData<GetIpCardsResponse>>({
            url: '/eureka/ip-home-page/ip-cards',
            method: 'GET',
        }).then((res) => {
            return res?.data as unknown as GetIpCardsResponse;
        });
    }

    getIpProfileToken() {
        return this.get<PatSnapCommonResponseData<string>>({
            url: '/eureka/ip-home-page/ip-profile-token',
            method: 'GET',
        }).then((res) => {
            return res?.data as string;
        });
    }
}
